
import React from 'react';
import { cn } from "@/lib/utils";
import { images } from '@/assets/images';

interface EquiForgeLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
  variant?: 'full' | 'compact' | '3d';
  className?: string;
  showText?: boolean;
}

const EquiForgeLogo: React.FC<EquiForgeLogoProps> = ({ 
  size = 'lg', 
  variant = '3d',
  className,
  showText = true
}) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-20',
    xxl: 'h-24',
    xxxl: 'h-40'
  };
  
  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
    xl: 'text-2xl',
    xxl: 'text-3xl',
    xxxl: 'text-4xl'
  };

  // Variant mapping:
  // - '3d': 3D yellow/purple wordmark (includes text)
  // - 'compact': Flame icon only (can optionally show text)
  // - 'full': Flat wordmark (includes text)
  const logoSrc = variant === '3d' 
    ? images.equiforgeLogo3d 
    : variant === 'compact' 
    ? images.equiforgeFlameLogo 
    : images.equiforgeLogoFlat;
  
  // Only show separate text for compact variant when showText is true
  const shouldShowSeparateText = variant === 'compact' && showText;

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <div className={cn(
        "relative flex items-center justify-center rounded-lg overflow-hidden",
        sizeClasses[size]
      )}>
        <img 
          src={logoSrc}
          alt="EquiForge Logo"
          className={cn(
            "w-auto object-contain transition-all duration-300",
            sizeClasses[size]
          )}
        />
      </div>
      {shouldShowSeparateText && (
        <div className="flex flex-col">
          <span className={cn(
            "font-bold text-foreground tracking-tight",
            textSizeClasses[size]
          )}>
            EquiForge™
          </span>
          {(size === 'lg' || size === 'xl' || size === 'xxl') && (
            <span className="text-xs text-muted-foreground">
              Advanced Mortgage Analysis
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default EquiForgeLogo;
